<div class="messenger-container">
  <div class="messenger-message"
       @slideFromToRight
       *ngFor="let message of service.messages"
  >
    <ngb-alert [dismissible]="true"
               [type]="message.severity"
               (close)="service.close(message)"
    >
      <strong *ngIf="message.title">{{ message.title }}</strong> {{ message.text }}
    </ngb-alert>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/messenger.component.html